<template>
    <section :id="component.identifier ? component.identifier : ''" class="mb-64" v-if="show">
        <component-header :title="title" :description="description"></component-header>

        <component :is="'style'" v-html="customStyles"></component>

        <div :class="[ type === 'fullWidth' ? 'w-full' : 'site__container']">
            <div
                ref="locations"
                class="locations w-full site__rounded--medium"
                :data-locations="JSON.stringify(component.locations)"
                :class="[ type === 'fullWidth' ? '' : 'site__rounded--medium overflow-hidden border border-primary-20', classMdFlex, classMdH480]">

                <div v-if="showLocationList" class="h-full overflow-y-auto scroll-styled h-480" :class="[classMdW12]">
                    <ul class="flex flex-col h-full">
                        <li
                            v-for="(location, index) in component.locations"
                            :key="location.id"
                            class="flex-grow"
                            :class="[ index !== (component.locations.length-1) ? 'border-b-2 border-primary-20' : '' ]"
                        >
                            <div
                                class="px-32 py-24 block leading-normal trans-ease location-link h-full flex flex-col justify-center"
                                :data-location-id="location.id">

                                <div class="font-semibold text-heading-1 mb-8">
                                    {{ name(location) }}
                                </div>

                                <div>
                                    <div class="flex mb-4">
                                        <span class="opacity-50">
                                            <svg class="w-16 h-16 block fill-current mt-2 mr-8 flex-none" viewBox="0 0 14 16">
                                                <path d="M7 0C3.1 0 0 3.1 0 7c0 1.9.7 3.7 2.1 5 .1.1 4.1 3.7 4.2 3.8.4.3 1 .3 1.3 0 .1-.1 4.2-3.7 4.2-3.8 1.4-1.3 2.1-3.1 2.1-5 .1-3.9-3-7-6.9-7zm0 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                                            </svg>
                                        </span>

                                        <span>{{ location.street }}</span>
                                    </div>

                                    <div class="flex mb-4">
                                        <span>{{ cityname(location) }}</span>
                                    </div>

                                    <div class="flex flex-wrap">
                                        <div v-if="location.phone" class="flex items-center flex-none mr-16">
                                            <span class="opacity-50">
                                                <svg class="w-16 h-16 block fill-current mr-8 flex-none" viewBox="0 0 16 16">
                                                    <path d="M15.285 11.89l-2.578-2.594a1 1 0 0 0-1.416-.002L9 11.585l-5-5 2.294-2.294a1 1 0 0 0 .001-1.414L3.715.293a1 1 0 0 0-1.415 0L.004 2.588 0 2.585c0 7.18 5.82 13 13 13l2.283-2.283a1 1 0 0 0 .002-1.412"/>
                                                </svg>
                                            </span>

                                            <a :href="'tel:' + location.phone" onclick="event.stopPropagation()">
                                                <span>
                                                    {{ location.phone }}
                                                </span>
                                            </a>
                                        </div>

                                        <div v-if="location.email" class="flex items-center flex-none">
                                            <span class="opacity-50">
                                                <svg class="w-16 h-14 block fill-current mr-8 flex-none" viewBox="0 0 16 14">
                                                    <path d="M15 0c.6 0 1 .4 1 1v1.5L8 6.9 0 2.4V1c0-.6.4-1 1-1h14zM7.5 8.9c.28.14.72.14 1 0L16 4.7V13c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V4.7l7.5 4.2z"/>
                                                </svg>
                                            </span>

                                            <a :href="'mailto:' + location.email" onclick="event.stopPropagation()">
                                                <span>
                                                    {{ location.email }}
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="locations-map site__color--brand"
                    :class="[showLocationList ? classMdW12 : (type === 'fullWidth' ? 'w-full' : 'w-full site__rounded--medium'), class288MdFull]">
                    <template v-if="runningInBrowser">
                        <div class="bg-semantic-error w-full h-full"
                             style="background: url('/app/img/Branding--Dummy-map.jpg') no-repeat; background-size: cover; background-position: center"></div>
                    </template>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { responsive, runningInBrowser, mapbox } from '../../helpers';
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding'
import ComponentHeader from './ComponentHeader.vue';

export default {
    components: {
        'component-header': ComponentHeader,
    },
    props: {
        component: {
            required: true,
        }
    },
    data: function () {
        return {
            type: '',
        }
    },
    computed: {
        ...mapState(useCommonStore, ['locale']),
        ...mapState(useBrandingStore, ['preview', 'brandHSLA']),
        show () {
            return runningInBrowser() || this.hasContent;
        },
        hasContent () {
            return this.component.locations && !!this.component.locations.length;
        },
        runningInBrowser () {
            return runningInBrowser();
        },
        title: {
            get () {
                return this.translated(this.component.title);
            }
        },
        description: {
            get () {
                return this.translated(this.component.description);
            }
        },
        hasMultipleLocations () {
            return this.component.locations.length > 1;
        },
        showLocationList () {
            return this.hasMultipleLocations && this.type !== 'fullWidth';
        },
        customStyles () {
            return `.mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
                border-bottom-color: ${ this.brandHSLA };
            }`
        },
        classMdW12() {
            return responsive(this.preview.type, 'md:w-1/2');
        },
        class288MdFull() {
            return responsive(this.preview.type, 'h-288 md:h-full');
        },
        classMdFlex() {
            return responsive(this.preview.type, 'md:flex');
        },
        classMdH480() {
            return responsive(this.preview.type, 'md:h-480');
        }
    },
    methods: {
        cityname (location) {
            return location.postal_code.trim().length === 0 ?
                location.city :
                location.postal_code + ' ' + location.city;
        },
        name (location) {
            return this.translated(location.alias, null, true) ?
                this.translated(location.alias, null, true) : location.city;
        }
    },
    mounted () {
        /*if (runningInBrowser()) {
            mapbox(this.$refs.locations);
        }*/

        this.$emit('loaded');
    }
}
</script>

<style>
.mapboxgl-popup-content {
    background: none!important;
    padding: 0!important;
    box-shadow: none!important;
}

.mapboxgl-popup {
    max-width: 100%!important;
}

.mapboxgl-container .leaflet-marker-icon {
  cursor: pointer;
}

.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip,
.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip {
    display: none;
}
</style>
